import { Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { CommonService } from '@app/shared/services/common/common.service';
import { MessageService } from '@app/shared/services/common/message.service';
import { AddProductPopupComponent } from '../add-product-popup/add-product-popup.component';
// import * as introJs from 'intro.js/intro.js';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  ProfileimageSrc !: any;
  FullName !: any;
  storeGalleryPermission:string = "StoreGallery";
  productCatalogPermission:string = "ProductCatalog";
  productLibraryPermission:string = "ProductLibrary";
  publishedProductPermission:string = "PublishedProduct";
  commissionPermission:string = "Commission";
  trackOrdersPermission:string = "TrackOrders";
  invoiceDetailPermission:string = "InvoiceDetails";
  pendingPaymentsPermission:string = "PendingPayments";
  reportBugPermission:string = "ReportABug";
  requestColorPermission:string = "RequestAColor";
  teamPermission:string = "Team";
  settingPermission:string = "Setting";
  availablePermissionList: string[] = []

  constructor(private messageService: MessageService, private common: CommonService,
    private router: Router) {
    this.messageService.getMessage().subscribe(message => {
      this.ProfileimageSrc = [];
      this.ProfileimageSrc = message[0];
      this.ProfileimageSrc = message.message['profileImage'];
      this.FullName = message.message['profileName'];
    });
  }

  public extendShopifyDesign = '';
  ngOnInit() {
    $(document).ready(function () {
      $('.sd-tgl-btn').click(function (e) {
        e.stopPropagation();
        $('body').toggleClass('showtoggle');
      });

      //Show side bar on more then small size device, so adding class "showtoggle"
      if ($(window)[0].screen.availWidth > 780)
        $('body').addClass('showtoggle');

      //on clicking any where just close the side bar in small devices
      $('body').click(function (e) {
        if ($(window)[0].screen.availWidth <= 780)
          $('body').removeClass('showtoggle');
      });


    });

    this.common.subShopifyDesign().subscribe((res: { shopify: boolean }) => {
      if (res.shopify) {
        $('body').addClass('showtoggle');
        this.extendShopifyDesign = 'designShopify';
      } else {
        this.extendShopifyDesign = '';

      }
    });
    this.ProfileimageSrc = [];
    this.ProfileimageSrc = localStorage.getItem('profileImage') !== 'null' ? localStorage.getItem('profileImage') : 'assets/img/default_user_img.png';
    this.FullName = [];
    this.FullName = localStorage.getItem('profileName');
    this.fn_getPermission();
  }

  fn_getPermission(){
    this.common.GetPermissionList(parseInt(localStorage.getItem('userId'))).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.availablePermissionList = res.Data.ResponseData
      }
    })
  }
  showAddProductWindow() {
    this.router.navigate(['/store/addproduct']);
  }

  hasPermission(value:string){
    if(localStorage.getItem('role') !== 'StoreStaffMember')
    return true;
    
    let hasValue =  this.availablePermissionList.find(x => x.toLowerCase().includes(value.toLowerCase()))
    if(hasValue != null)
    return true;
    else
    return false;
  }
}
